export type AuthGroup = 'Super Admin' | 'Organization Admin' | 'Group Admin' | 'Designer' | 'Respondant';

export enum UserType{
    'Super Admin'='Super Admin',
    'Designer'='Designer',
    'Organization Admin'='Organization Admin',
    'Group Admin'='Group Admin',
    'Respondent'='Respondent'
}
export enum UserTypeId{
    'Super Admin'=1,
    'Designer'=2,
    'Organization Admin'=5,
    'Group Admin'=4,
    'Respondent'=3}